import metaPages from './metaPages'
import faqGroups from './faqGroups'
import faq from './faq'
import categories from './categories'
import banners from './banners'
import blog from './blog'

export default {
  seo: {
    namespaced: true,
    modules: {
      metaPages,
      faqGroups,
      faq,
      categories,
      banners,
      blog
    }
  }
}
